import { useNavigate } from 'react-router-dom';
import { useConsultations } from '../../../../../../hooks/fetchers/useConsultations/useConsultations';
import { useMergedStatesFromFetchers } from '../../../../../../hooks/useMergedStatesFromFetchers/useMergedStatesFromFetchers';
import Loading from '../../../../../commons/Loading/Loading';
import Empty from '../../../../../commons/Empty/Empty';
import Button from '../../../../../designSystem/Button/Button';
import { getChipContentByStepId } from '../../../../../../utils/helpers/consultation/getChipContentByStepId';
import { ButtonSize } from '../../../../../designSystem/Button/Button.types';

export default () => {
  const navigate = useNavigate();

  const {
    data: consultations,
    isLoading: isConsultationsLoading,
    isFetching: isConsultationsFetching,
    isError: isConsultationsError,
  } = useConsultations({ page: 1, perPage: 11 });

  const { isLoading } = useMergedStatesFromFetchers({
    loadings: [isConsultationsLoading, isConsultationsFetching],
  });

  return (
    <table className="dashboard__table dashboard-commerciaux__table">
      {isLoading || isConsultationsError ? (
        isConsultationsError ? (
          <div className="flex-column">
            <Empty>Aucune consultation pour le moment</Empty>
            <Button
              style={{ alignSelf: 'center' }}
              onClick={() => navigate('/dashboard/nouvelle_consultation')}>
              Déposer une consultation
            </Button>
          </div>
        ) : (
          <Loading />
        )
      ) : (
        <>
          <thead>
            <tr>
              <th>Titre</th>
              <th>Type</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {consultations?.results.map((consultation, index) => {
              const { id, title, id_step, type } = consultation;
              const { label } = getChipContentByStepId(consultation);
              if (index < 10) {
                return (
                  <tr
                    key={index}
                    onClick={() =>
                      id_step < 4
                        ? navigate(`/dashboard/nouvelle_consultation/${id}`)
                        : navigate(`/dashboard/consultations/${id}`)
                    }
                    className={
                      id_step < 4
                        ? 'dashboard-commerciaux__table-tr--clickable'
                        : 'dashboard-commerciaux__table-tr--clickable'
                    }>
                    <td>{title}</td>
                    <td>{type}</td>
                    <td className="text-primary">{label}</td>
                  </tr>
                );
              } else {
                return null;
              }
            })}
          </tbody>
          {consultations && consultations.total > 10 && (
            <Button
              className="dashboard__table-button--large"
              size={ButtonSize.Large}
              onClick={() => navigate('/dashboard/consultations')}>
              Voir tout
            </Button>
          )}
        </>
      )}
    </table>
  );
};
